import { render } from "./ProjetPokePuller.vue?vue&type=template&id=64e4f33a&scoped=true"
import script from "./ProjetPokePuller.vue?vue&type=script&lang=js"
export * from "./ProjetPokePuller.vue?vue&type=script&lang=js"

import "./ProjetPokePuller.vue?vue&type=style&index=0&id=64e4f33a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e4f33a"]])

export default __exports__